import React from 'react';

const LabelQuestion = (props) => {
  const { label, htmlFor, icon = 'fe-help-circle', style = {}, question, labelClass } = props;

  return (
    <label className={labelClass} htmlFor={htmlFor} style={style}>
      {label}
      {question ? (
        <span className="help-tooltip-wrapper">
          <i className={icon} />
          <span className="help-tooltip">{question}</span>
        </span>
      ) : null}
    </label>
  );
};

export default LabelQuestion;
